import React, { useEffect, useState } from "react";
import Card from "../../../components/Card";
import { Link } from "react-router-dom";
import ProfileHeader from "../../../components/profile-header";
import {
  Row,
  Col,
  Tab, 
  Nav,
  Container,
  Dropdown,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import img1 from "../../../assets/images/page-img/profile-bg1.jpg";
import { getToken } from "../../../utils/auth";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { MdOutlineDone } from "react-icons/md";
import useAuth from "../../../utils/useAuth";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../Context/UserContext";
import { CircularProgress } from "@mui/material";

const GroupProfile = (userUid) => {
  useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);
  const { t, i18n } = useTranslation();
  const [groupName, setGroupName] = useState();
  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState('');
  const [loadingFull, setLoadingFull] = React.useState(false);

  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
};
const closeQrPopup = () => {
  setQrPopupOpen(false);
};
  const handleGroupDetail = () => {
    // navigate(`/group-detail`);
    navigate(`/group-detail/${groupName}`);
  };
  const handleNavigate = (id) => {
    navigate(`/group-detail/${id}`);
  };

  const [groups, setGroups] = useState([]);
  const handleAllGroups = async () => {
    try {
      setLoadingFull(true)
      const token = getToken();
      let url = `${process.env.REACT_APP_URL}/api/group/all?userId=${userUid?.userUid}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setGroups(response.data.data);
    } catch (error) {
      console.log("Failed Fetching Group", error);
    } finally{
      setLoadingFull(false)
    }
  };
  useEffect(() => {
    handleAllGroups();
  }, []);
  const [currentDate, setCurrentDate] = useState("");

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  useEffect(() => {
    const intervalId = setInterval(() => {
      const date = new Date();
      const dayOfMonth = date.getDate();
      setCurrentDate(dayOfMonth);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);
  const handleJoinGroup = async (groupID, isPrivate) => { 
    setGroupName(groupID);
    try {
      setLoadingFull(true)

      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/group/join/${groupID}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(response.data.message);
      handleAllGroups()
      if (!isPrivate) {
        handleShow1();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed Joining Group");
      console.log("Failed Joining Group", error);
    } finally{
      setLoadingFull(false)
    }
};

  const { userData } = useUser();

    const [user, setUser] = useState("");
    const fetchUserData = async () => {
      try {
        const token = getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/user`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log("user details header", response.data.data);
        setUser(response?.data?.data);
      } catch (error) {
        console.error("Failed Fetching Details", error);
      }
    };
    useEffect(() => {
        fetchUserData();
    },[])

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
  {loadingFull && (
    <div style={styles.loaderOverlay}>
      <CircularProgress style={{ color: "white" }} />
    </div>
  )}
{/* <ProfileHeader  img={img7} title="Groups" /> */}
          <div>
            <Col lg="12">
                      <Modal centered
                        size="md"
                        className=""
                        id="post-modal"
                        onHide={handleClose1}
                        show={show1}
                        style={{
                          marginTop: "17%",
                          zIndex: "999999",
                          overflow: "hidden",
                        }}
                      >
                        <Modal.Header
                          className=""
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            borderBottom: "none",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              flexDirection: "column",
                            }}
                          >
                            <Link
                              // to="#"
                              className="lh-1"
                              style={{
                                display: "flex",
                                justifyContent: "right",
                              }}
                              onClick={handleClose1}
                            >
                              <span className="material-symbols-outlined">
                                close
                              </span>
                            </Link>

                            <Modal.Title
                              id="post-modalLabel"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                fontSize: "24px",
                                paddingBlock: "30px",
                                textAlign: "center",
                              }}
                            >
                              {t('congratulations_in_group')}
                            </Modal.Title>
                          </div>
                          <button
                            type="submit"
                            style={{ display: "flex" }}
                            className="btn btn-primary d-block w-100 mt-3"
                            onClick={handleGroupDetail}
                          >
                            {t('visit_group')}
                          </button>
                        </Modal.Header>
                      </Modal>
                           <Modal size="sm" className="fade" id="qr-modal" onHide={closeQrPopup} show={qrPopupOpen} centered >
                                      <Modal.Header closeButton>
                                          <Modal.Title>{t('qr_code')}</Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body className="text-center">
                                          <img src={qrImageUrl} alt="QR Code" style={{ maxWidth: '100%', height: 'auto' }} />
                                      </Modal.Body>
                                      <Modal.Footer>
                                          <button className="btn btn-secondary" onClick={closeQrPopup}>{t('close')}</button>
                                      </Modal.Footer>
                      
                                  </Modal>
                    <div className="d-grid gap-3 d-grid-template-1fr-19" >
                      {groups && groups?.length > 0 ? (
                        groups?.map((data) => (
                          <Card className="mb-0">
                            <div className="position-relative">
                              <img
                                loading="lazy"
                                src={data?.backgroundImageLink || img1}
                                alt="profile-bg"
                                style={{height:"120px", width:"100%"}}
                                className="rounded img-fluid"
                              />
<ul 
  className="header-nav list-inline d-flex align-items-center p-0 m-0" 
  style={{ width: "100%", display: "flex", justifyContent: "space-between" }}
>
  {data?.category === "public" && (
  <li style={{ visibility: data?.qrCodeUrl ? "visible" : "hidden", marginLeft:"20px" }}>
    {data?.qrCodeUrl && (
      <img src={data?.qrCodeUrl} style={{ width: "50px", height: "50px" }}  onClick={() => handleQrClick(data?.qrCodeUrl)}/>
    )}
  </li>)}
  
 
</ul>
                            </div>
                            <Card.Body className=" text-center">
                              <div className="group-icon">
                                <img
                                  src={
                                    data?.uploadedFileLink
                                      ? data?.uploadedFileLink
                                      : "/profile.png"
                                  }
                                  alt="profile-img"
                                  style={{ position: "relative" }}
                                  className="rounded-circle img-fluid avatar-120"
                                />
                              </div>
                              <div className="group-info pt-3 ">
                                <h4>
                                  <Link
                                    // onClick={() => handleNavigate(data?._id)}
                                  >
                                    {data?.groupName}
                                  </Link>
                                  <div className="text-primary" style={{textTransform:"capitalize", fontSize:"12px"}}>({data?.category})</div>

                                </h4>
                                {/* <div
                                  style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: data?.description,
                                  }}
                                ></div> */}
                              </div>
                              {data?.note ? (
    <div
      style={{
        color: "red",
        fontSize: "14px",
        marginTop: "10px",
        textAlign: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
      }}
    >
      {t("note")}: {data?.note}
    </div>
  ) : (
    <div style={{ visibility: "hidden", height: "25px", marginTop: "10px" }}>
      {/* Hidden placeholder for alignment */}
    </div>
  )}

                              <div className="group-details d-inline-block pb-3">
                                <ul className="d-flex align-items-center justify-content-between list-inline m-0 p-0">
                                  <li className="pe-3 ps-3">
                                    <p className="mb-0">{t('post')}</p>
                                    <h6>{data?.postCount}</h6>
                                  </li>
                                  <li className="pe-3 ps-3">
                                    <p className="mb-0">{t('member')}</p>
                                    <h6>{data?.memberCount}</h6>
                                  </li>
                                </ul>
                              </div>
                              {data?.category === 'private' ? (
  <button
    type="submit"
    className="btn btn-primary d-block w-100"
    onClick={() => handleJoinGroup(data?._id, true)}
  >
    {t('request')}
  </button>
) : (
  <button
    type="submit"
    className="btn btn-primary d-block w-100"
    onClick={() => handleJoinGroup(data?._id, false)}
  >
    {t('join')}
  </button>
)}

                            </Card.Body>
                          </Card>
                        ))
                      ) : (
                        <p>{t('no_groups_available')}</p>
                      )}
                    </div>
            </Col>
          </div>

    </>
  );
};

const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export default GroupProfile;
